import React from 'react';
import { store } from '../../store'

import connectWithStore from '../../utils/store'

import { fetchCases } from '../../api/cases/actions';
import { agentCasesFilterDefaults } from '../../api/cases/reducers';
import moment from 'moment'
import { formatKennitala } from '../../utils';
import { SvgArrowIcon, SvgCloseIcon } from '../svg';
import { clearCaseResolveResponse, setAgentCasesFilters } from '../../api/cases/actions';

const AGENT_THRESHOLD = 1;
const CUSTODIAN_THRESHOLD = 1;
const FILTER_DEFAULTS = agentCasesFilterDefaults;
    
class AgentCases extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            filtersExpanded: false,
        }

        this.statusFilter = this.statusFilter.bind(this)
        this.dateFilter = this.dateFilter.bind(this)
        this.agentFilter = this.agentFilter.bind(this)
        this.setAgent = this.setAgent.bind(this)
        this.custodianFilter = this.custodianFilter.bind(this)
        this.setCustodian = this.setCustodian.bind(this)

        this.toggleFilters = this.toggleFilters.bind(this)
        this.toggleOrder = this.toggleOrder.bind(this)

        this.clearResolveTimeoutId = null
    }

    componentDidMount() {
        this.props.dispatch(fetchCases())
    }

    componentDidUpdate(prevProps) {
        const prevResolvedCaseId = prevProps.caseResolveResponse && !prevProps.isResolvingCase && !prevProps.caseResolveError && prevProps.caseResolveResponse.Case
            ? prevProps.caseResolveResponse.Case.CaseId
            : null

        const resolvedCaseId = this.props.caseResolveResponse && !this.props.isResolvingCase && !this.props.caseResolveError && this.props.caseResolveResponse.Case
            ? this.props.caseResolveResponse.Case.CaseId
            : null

        if (!prevResolvedCaseId && resolvedCaseId) {
            if (this.clearResolveTimeoutId) {
                clearTimeout(this.clearResolveTimeoutId)
            }

            this.clearResolveTimeoutId = setTimeout(() => {
                this.props.dispatch(clearCaseResolveResponse())
                this.clearResolveTimeoutId = null
            }, 3000)
        }
    }

    componentWillUnmount() {
        if (this.clearResolveTimeoutId) {
            clearTimeout(this.clearResolveTimeoutId)
            this.clearResolveTimeoutId = null
        }
    }

    statusFilter(value) {
        this.props.dispatch(setAgentCasesFilters({ statusFilter: value }))
    }

    dateFilter(value) {
        this.props.dispatch(setAgentCasesFilters({ dateFilter: value }))
    }

    agentFilter(e) {
        this.setAgent(e.target.value)
    }

    setAgent(value) {
        this.props.dispatch(setAgentCasesFilters({ agentFilter: value }))
    }

    
    custodianFilter(e) {
        this.setCustodian(e.target.value)
    }

    setCustodian(value) {
        this.props.dispatch(setAgentCasesFilters({ custodianFilter: value }))
    }

    toggleFilters() {
        this.setState(prevState => ({
            filtersExpanded: !prevState.filtersExpanded,
        }))
    }

    toggleOrder(field) {
        const filters = this.props.agentCasesFilters || FILTER_DEFAULTS;
        if (filters.order.direction === 'asc') {
            this.props.dispatch(setAgentCasesFilters({ order: {field: field, direction:'desc' }}))
        } else {
            this.props.dispatch(setAgentCasesFilters({ order: {field: field, direction:'asc' }}))
        }
    }

    getCaseKey(caseItem) {
        return String(caseItem.CeItemId || caseItem.CaseId || caseItem.token)
    }

    getPrimaryKennitala(caseItem) {
        if (caseItem.signer_ids && caseItem.signer_ids.length > 0) {
            return caseItem.signer_ids[0]
        }

        if (caseItem.people) {
            const peopleKeys = Object.keys(caseItem.people)
            return peopleKeys.length > 0 ? peopleKeys[0] : null
        }

        if (caseItem.Name && typeof caseItem.Name === 'string') {
            const match = caseItem.Name.match(/^(\d{10})\s*-/)
            if (match && match[1]) {
                return match[1]
            }
        }

        return null
    }

    getPrimaryCustomerName(caseItem) {
        if (caseItem.Name && typeof caseItem.Name === 'string') {
            const splitName = caseItem.Name.split(' - ')
            if (splitName.length > 1 && splitName[1]) {
                return splitName[1]
            }
            return caseItem.Name
        }

        const kennitala = this.getPrimaryKennitala(caseItem)
        return (kennitala && caseItem.people && caseItem.people[kennitala]) ? caseItem.people[kennitala] : '-'
    }

    getAgentName(caseItem) {
        return caseItem.AdvisorName || caseItem.AdvisorSSN || caseItem.AdvisorCode
    }

    getCustodianName(caseItem) {
        return caseItem.CustodianName
    }    

    getStatusCategory(caseItem) {
        const subCategoryText = String(caseItem.SubCategoryText || caseItem.SubCategory || '').trim()
        const normalized = subCategoryText.toLowerCase()

        if (!normalized) {
            return 'other'
        }

        if (normalized.includes('fyrri sjóð')) {
            return 'previousFund'
        }
        if (normalized.includes('uppsögn')) {
            return 'terminations'
        }
        if (normalized.includes('skilríki')) {
            return 'photoid'
        }
        if (normalized.includes('heilsufarsupplýsingar')) {
            return 'health'
        }
        if (normalized.includes('vantar gögn')) {
            return 'missing'
        }

        return 'other'
    }

    getActiveFilterCount(filters) {
        let activeFilterCount = 0

        if (filters.dateFilter !== FILTER_DEFAULTS.dateFilter) {
            activeFilterCount += 1
        }
        if (filters.statusFilter !== FILTER_DEFAULTS.statusFilter) {
            activeFilterCount += 1
        }
        if (filters.agentFilter !== FILTER_DEFAULTS.agentFilter) {
            activeFilterCount += 1
        }
        if (filters.custodianFilter !== FILTER_DEFAULTS.custodianFilter) {
            activeFilterCount += 1
        }

        return activeFilterCount
    }

    getFilterStatusText(activeFilterCount) {
        if (activeFilterCount === 0) {
            return 'Engar síur'
        }
        if (activeFilterCount === 1) {
            return '1 sía virk'
        }
        return `${activeFilterCount} síur virkar`
    }

    render() {

        const {agentCases} = this.props
        const filters = this.props.agentCasesFilters || FILTER_DEFAULTS
        const agents = agentCases && agentCases.agents ? agentCases.agents : []
        const custodians = agentCases && agentCases.custodians ? agentCases.custodians : []
        let is_boss = false;

        if (agentCases.isFetching) {
            return null
        }

        let cases = []

        let today = moment.utc()
        if (agentCases && agentCases.cases) {
            is_boss = agentCases.is_boss
            cases = [...agentCases.cases]

            let sevenDayAhead = moment.utc().add(7, 'days')
            let fourteenDaysAhead = moment.utc().add(14, 'days')

            if (filters.agentFilter !== '') {
                cases = cases.filter(c => this.getAgentName(c) === filters.agentFilter)
            }

            if (filters.custodianFilter !== '') {
                cases = cases.filter(c => this.getCustodianName(c) === filters.custodianFilter)
            }


            const dateCounts = {
                all: cases.length,
                today: 0,
                '7days': 0,
                '14days': 0,
            }

            cases.forEach(c => {
                const dueDate = c.DueDate;
                if (!dueDate) {
                    return
                }
                if (dueDate.isSameOrBefore(today, 'day')) {
                    dateCounts.today += 1
                }
                if (dueDate.isSameOrBefore(sevenDayAhead, 'day')) {
                    dateCounts['7days'] += 1
                }
                if (dueDate.isSameOrBefore(fourteenDaysAhead, 'day')) {
                    dateCounts['14days'] += 1
                }
            })

            switch(filters.dateFilter) {
                case 'today':
                    cases = cases.filter(c => {
                        const dueDate = c.DueDate;
                        return dueDate ? dueDate.isSameOrBefore(today, 'day') : false
                    })
                    break;
                case '7days':
                    cases = cases.filter(c => {
                        const dueDate = c.DueDate;
                        return dueDate ? dueDate.isSameOrBefore(sevenDayAhead, 'day') : false
                    })
                    break;
                case '14days':
                    cases = cases.filter(c => {
                        const dueDate = c.DueDate;
                        return dueDate ? dueDate.isSameOrBefore(fourteenDaysAhead, 'day') : false
                    })
                    break;
            }

            const casesForStatusCounters = [...cases]
            const statusCounts = {
                all: casesForStatusCounters.length,
                terminations: 0,
                photoid: 0,
                health: 0,
                missing: 0,
                previousFund: 0,
                other: 0,
            }

            casesForStatusCounters.forEach(c => {
                const category = this.getStatusCategory(c)
                if (statusCounts[category] !== undefined) {
                    statusCounts[category] += 1
                } else {
                    statusCounts.other += 1
                }
            })

            switch(filters.statusFilter) {
                case 'terminations':
                case 'photoid':
                case 'health':
                case 'missing':
                case 'previousFund':
                case 'other':
                    cases = cases.filter(c => this.getStatusCategory(c) === filters.statusFilter)
                    break;
                case 'all':
                default:
                    break;
            }

            cases = cases.sort((aItm, bItm) => {
                const sortOrder = filters.order;
                const a = aItm[sortOrder.field];
                const b = bItm[sortOrder.field];

                if (!a && !b) {
                    return 0
                }
                if (!a) {
                    return 1
                }
                if (!b) {
                    return -1
                }

                if (filters.order.direction === 'asc') {
                    return a.diff(b)
                } else {
                    return b.diff(a)
                }
            })

            this.statusCounts = statusCounts
            this.dateCounts = dateCounts
        } else {
            this.statusCounts = {
                all: 0,
                terminations: 0,
                photoid: 0,
                health: 0,
                missing: 0,
                previousFund: 0,
                other: 0,
            }
            this.dateCounts = {
                all: 0,
                today: 0,
                '7days': 0,
                '14days': 0,
            }
        }

        const lastCaseResolved = this.props.caseResolveResponse && !this.props.isResolvingCase && !this.props.caseResolveError && this.props.caseResolveResponse.Case
            ? this.props.caseResolveResponse.Case.CaseId
            : null
        const activeFilterCount = this.getActiveFilterCount(filters)
        const hasActiveFilters = activeFilterCount > 0

        return (<>
            <style>{`
                .agent-contracts input[type="checkbox"] {
                    position: unset;
                    top: unset;
                    left: unset;
                    transform: unset;
                    opacity: unset;
                    margin-right: 10px;
                }
                .agent-cases-filter-heading {
                    margin-bottom: 15px;
                }
                .agent-cases-layout {
                    position: relative;
                }
                .agent-cases-table-column {
                    order: 1;
                    min-width: 850px;
                    overflow-x: scroll;
                }
                .agent-cases-filter-column {
                    margin-top: -40px;
                    order: 2;
                }
                .agent-cases-filter-column.is-collapsed {
                    position: absolute;
                    right: 15px;
                    top: 50px;
                    width: auto;
                    z-index: 2;
                }
                .agent-cases-filter-column.is-collapsed .agent-cases-filter-heading {
                    margin-bottom: 0;
                }
                .agent-cases-filter-toggle {
                    align-items: center;
                    background: none;
                    border: 0;
                    color: inherit;
                    cursor: pointer;
                    display: flex;
                    font: inherit;
                    justify-content: space-between;
                    padding: 0;
                    text-align: left;
                    width: 100%;
                }
                .agent-cases-filter-column.is-collapsed .agent-cases-filter-toggle {
                    background: #fff;
                    border: 1px solid #d8d8d8;
                    border-radius: 4px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                    padding: 8px 10px;
                    width: auto;
                }
                .agent-cases-filter-title {
                    align-items: center;
                    display: inline-flex;
                    min-width: 0;
                }
                .agent-cases-filter-status {
                    align-items: center;
                    color: #666;
                    display: inline-flex;
                    font-size: 12px;
                    font-weight: 600;
                    margin-left: 10px;
                    white-space: nowrap;
                }
                .agent-cases-filter-status:before {
                    background: #b5b5b5;
                    border-radius: 50%;
                    content: "";
                    display: inline-block;
                    height: 8px;
                    margin-right: 6px;
                    width: 8px;
                }
                .agent-cases-filter-status.is-active {
                    color: #006192;
                }
                .agent-cases-filter-status.is-active:before {
                    background: #007ab3;
                }
                .agent-cases-filter-arrow {
                    display: inline-flex;
                    margin-left: 10px;
                    width: 12px;
                }
                .agent-cases-filter-arrow svg {
                    display: block;
                    width: 12px;
                }
                .agent-cases-filter-body {
                    margin-top: 10px;
                }
                .origin-of-dismissal {
                    font-size: 10px;
                    color: red;
                }
                .origin-of-dismissal.green {
                    color: green;
                }
                @media (max-width: 1184px) {
                    .agent-cases-table-column {
                        order: 2;
                    }
                    .agent-cases-filter-column {
                        order: 1;
                    }
                }
            `}</style>
            {
            lastCaseResolved  
            && <div className="container-fluid xs-pt-30 xs-pb-50"> 
                <div className="alert alert-warning">Mál {lastCaseResolved} klárað.</div>
               </div>
            }

            <div className="container-fluid xs-pt-10 xs-pb-50">
                <div className="row">
                    <div className="col-12 text-center xs-pt-50">
                        <h3>Mín mál</h3>
                        <p className="xs-mt-20">Mál í vinnslu síðustu 30 daga</p>
                    </div>
                </div>
                <div className="row agent-cases-layout">
                    <div className={`agent-cases-filter-column ${this.state.filtersExpanded ? 'col-12 col-xl-2 col-md-3 xs-pt-50 is-expanded' : 'is-collapsed'}`}>
                        <h4 className="agent-cases-filter-heading">
                            <button
                                type="button"
                                className="agent-cases-filter-toggle"
                                onClick={this.toggleFilters}
                                aria-expanded={this.state.filtersExpanded}
                                aria-controls="agent-cases-filters"
                            >
                                <span className="agent-cases-filter-title">
                                    <span>Síur</span>
                                    <span className={`agent-cases-filter-status ${hasActiveFilters ? 'is-active' : ''}`}>
                                        {this.getFilterStatusText(activeFilterCount)}
                                    </span>
                                </span>
                                <span className="agent-cases-filter-arrow">
                                    <SvgArrowIcon direction={this.state.filtersExpanded ? 'up' : 'down'} />
                                </span>
                            </button>
                        </h4>

                        <div id="agent-cases-filters" className="agent-cases-filter-body" hidden={!this.state.filtersExpanded}>
                            <a onClick={() => this.dateFilter('today')} className={`d-block xs-mb-5 btn btn-sm btn-${filters.dateFilter==='today' ? '': 'outline-'}primary`}>Komið á dag ({this.dateCounts.today})</a>
                            <a onClick={() => this.dateFilter('7days')} className={`d-block xs-mb-5 btn btn-sm btn-${filters.dateFilter==='7days' ? '' : 'outline-'}primary`}>Lokið innan 7 daga ({this.dateCounts['7days']})</a>
                            <a onClick={() => this.dateFilter('14days')} className={`d-block xs-mb-5 btn btn-sm btn-${filters.dateFilter==='14days' ? '': 'outline-'}primary`}>Lokið innan 14 daga ({this.dateCounts['14days']})</a>
                            <a onClick={() => this.dateFilter('all')} className={`d-block xs-mb-20 btn btn-sm btn-${filters.dateFilter==='all' ? '': 'outline-'}primary`}>Öll mál ({this.dateCounts.all})</a>

                            <a onClick={() => this.statusFilter('all')} className={`d-block xs-mb-5 btn btn-sm btn-${filters.statusFilter==='all' ? '': 'outline-'}primary`}>Allt ({this.statusCounts.all})</a>
                            <a onClick={() => this.statusFilter('terminations')} className={`d-block xs-mb-5 btn btn-sm btn-${filters.statusFilter==='terminations' ? '': 'outline-'}primary`}>Uppsagnir ({this.statusCounts.terminations})</a>
                            <a onClick={() => this.statusFilter('photoid')} className={`d-block xs-mb-5 btn btn-sm btn-${filters.statusFilter==='photoid' ? '': 'outline-'}primary`}>Skilríki ({this.statusCounts.photoid})</a>
                            <a onClick={() => this.statusFilter('health')} className={`d-block xs-mb-5 btn btn-sm btn-${filters.statusFilter==='health' ? '': 'outline-'}primary`}>Heilsufarsupplýsingar ({this.statusCounts.health})</a>
                            <a onClick={() => this.statusFilter('missing')} className={`d-block xs-mb-5 btn btn-sm btn-${filters.statusFilter==='missing' ? '': 'outline-'}primary`}>Vantar gögn ({this.statusCounts.missing})</a>
                            <a onClick={() => this.statusFilter('previousFund')} className={`d-block xs-mb-5 btn btn-sm btn-${filters.statusFilter==='previousFund' ? '': 'outline-'}primary`}>Uppsögn á fyrri sjóð ({this.statusCounts.previousFund})</a>
                            <a onClick={() => this.statusFilter('other')} className={`d-block xs-mb-20 btn btn-sm btn-${filters.statusFilter==='other' ? '': 'outline-'}primary`}>Annað ({this.statusCounts.other})</a>

                            { agents.length > AGENT_THRESHOLD &&
                                <>
                                    <select className="custom-select xs-mt-15" id="" name="occupation" onChange={this.agentFilter} value={filters.agentFilter}>
                                        <option value="">Veldu ráðgjafa</option>
                                        {agents.map(agent => {
                                            return <option key={`agent-option-${agent}`} value={agent}>{agent}</option>
                                        })}
                                    </select>
                                    { filters.agentFilter !== '' &&
                                        <div className="agent-select-clean check-container" onClick={(e) => this.setAgent('')}><span className="check check-icon small red"><SvgCloseIcon /></span></div>
                                    }
                                </>
                            }
                            { custodians.length > CUSTODIAN_THRESHOLD &&
                                <>
                                    <select className="custom-select xs-mt-15" id="" name="custodian" onChange={this.custodianFilter} value={filters.custodianFilter}>
                                        <option value="">Veldu vörsluaðila</option>
                                        {custodians.map(custodian => {
                                            return <option key={`custodian-option-${custodian}`} value={custodian}>{custodian}</option>
                                        })}
                                    </select>
                                    { filters.custodianFilter !== '' &&
                                        <div className="agent-select-clean check-container" onClick={(e) => this.setCustodian('')}><span className="check check-icon small red"><SvgCloseIcon /></span></div>
                                    }
                                </>
                            }                            
                        </div>
                    </div>

                { (agentCases && agentCases.cases) &&
                        <div className={`agent-cases-table-column ${this.state.filtersExpanded ? 'col-12 col-xl-10 col-md-9' : 'col-12'} xs-pt-50`}>
                            <table className="table agent-contracts">
                                <thead>
                                    <tr>
                                        <th>Samingsauðkenni</th>
                                        <th>Viðskiptavinur</th>
                                        <th>Kennitala-Tryggingarþega</th>
                                        <th>Samningsgerð</th>
                                        <th>Fráviksnúmer</th>
                                        <th>Flokkur</th>
                                        <th>Undirflokkur</th>
                                        <th>Vörsluaðili</th>
                                        <th><a role="button" onClick={() => this.toggleOrder('CreatedDate')}>Stofnað { filters.order.field==='CreatedDate' && (filters.order.direction === 'asc' ? <>&darr;</> : <>&uarr;</>)} </a></th>
                                        <th><a role="button" onClick={() => this.toggleOrder('DueDate')}>Lokadagur { filters.order.field==='DueDate' && (filters.order.direction === 'asc' ? <>&darr;</> : <>&uarr;</>) }</a></th>
                                        { is_boss && <th>Ráðgjafi</th> }
                                    </tr>
                                </thead>
                                <tbody>
                                    {cases.map(caseItem => {
                                        const primaryKennitala = this.getPrimaryKennitala(caseItem)
                                        const createdMoment = caseItem.CreatedDate
                                        const dueMoment = caseItem.DueDate
                                        const caseKey = this.getCaseKey(caseItem)
                                        const alreadyDue = dueMoment && dueMoment.isSameOrBefore(today)
                                        const extraOriginClass = caseItem.OriginOfDismissal === "Viðskiptavinur"? "green": ""
                                        return (
                                            <tr key={`agent-case-line-${caseKey}`}>
                                                <td>{caseItem.ContractId || '-'}</td>
                                                <td>
                                                    <a href={`/#/cases/${caseItem.CaseId}`}>
                                                        {this.getPrimaryCustomerName(caseItem)}
                                                    </a>
                                                </td>
                                                <td>{primaryKennitala ? formatKennitala(primaryKennitala) : '-'}</td>
                                                <td>{caseItem.ContractType}</td>
                                                <td>
                                                    <a href={`/#/cases/${caseItem.CaseId}`}>
                                                        {caseItem.CaseId || '-'}
                                                    </a>
                                                </td>
                                                <td>
                                                    {caseItem.CategoryText}
                                                    {caseItem.OriginOfDismissal
                                                    ?
                                                    <div className={`origin-of-dismissal ${extraOriginClass}`}>
                                                    {caseItem.OriginOfDismissal}
                                                    </div>
                                                    :
                                                    ""}
                                                    
                                                </td>
                                                <td>{caseItem.SubCategoryText}</td>
                                                <td>{caseItem.CustodianName}</td>
                                                <td>{createdMoment ? createdMoment.format('D.M.YYYY') : '-'}</td>
                                                <td style={{color: `${alreadyDue ? 'red' : 'inherit'}`}}>{dueMoment ? dueMoment.format('D.M.YYYY') : '-'}</td>
                                                { is_boss && <td>{this.getAgentName(caseItem)}</td>}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        
                }
                </div>
            </div>
        </>)
    }
}

AgentCases.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        agentCases: {},
        caseDetails: {},
        agentCasesFilters: FILTER_DEFAULTS,
    }
    f.agentCases = (state.agentCases === undefined) ? {} : state.agentCases
    f.agentCasesFilters = state.agentCases && state.agentCases.filters ? state.agentCases.filters : FILTER_DEFAULTS
    f.caseResolveResponse = state.caseDetails && state.caseDetails.caseResolveResponse ? state.caseDetails.caseResolveResponse : null
    f.isResolvingCase = state.caseDetails && state.caseDetails.isResolvingCase ? state.caseDetails.isResolvingCase : false
    f.caseResolveError = state.caseDetails && state.caseDetails.caseResolveError ? state.caseDetails.caseResolveError : false
    return f;
}

export default connectWithStore(store, AgentCases, mapStateToProps);
